const langs = {
  language: {
      name: '繁体中文',
  },
  common:{
      more:"更多>>",
      company:"澳门丁丁投资官网"
  },
  header:{
      home:'首頁',
      service:'產品服務',
      about:'關於我們',
      contact:'聯系我們',
      others:'企業門戶',
      other_option1:'醫生門戶',
      other_option2:'運營門戶'
  },
  footer:{
      tel_label:"聯系電話",
      tel_val:"853-28821988",
      email_label:"企業郵箱",
      company_address_label:"公司地址",
      company_address:"澳門新口岸馬濟時總督大馬路13號雙鑽第二棟11樓M",
      copyright:"版本所有@2022 丁丁健康投資發展有限公司",
      case_number:"備案號:粵ICP備2021001423號-1"
  },
  home:{
      company_profile:
      "澳門丁丁健康投資發展有限公司是壹家專註於大健康領域投資的領先企業，多年來壹直在國內布局線下創辦醫療機構和提供線上互聯網醫療服務業務。公司線上互聯網醫療板塊主要從事健康促進管理領域的信息技術研發，跨界整合雲架構移動互聯網技術和健康管理專業資源，以智能健康管理大數據平臺為核心，借助移動互聯網、IOT技術實現端到端的解決方案，協助各類機構、企業的健康管理部門延伸服務範圍、完善服務質量、提升服務效率，同時幫助個人用戶實現日常的健康自我管理與數據跟蹤蹤、分析。丁丁健康願努力成為每個人的貼身健康管家，使健康自我管理與健康促進成為大家每日生活中必需品。丁丁健康數字健康管理平臺成功地為醫療機構、體檢機構、社康中心、健管中心等單位提供健康管理的信息技術服務與支持。丁丁健康堅持技術持續創新、服務以人為本、不斷為客戶創造價值的發展理念，希望借助人工智能、大數據及移動互聯網的發展使更多的用戶可以關註自身健康、更容易地實現自我健康管理與促進、更好地享受健康生活。",
      health_intervention:"健康幹預",
      health_intervention_desc:"通過無縫、高效的健康幹預服務，丁丁健康可以幫助客戶隨時隨地掌握自己的健康狀況、促進目標。了解健康促進計劃與效果，從而有計劃、有步驟地以多種形式改善個人的生活方式和習慣，實現個人健康管理計劃的目標。",
      partner_organization:"合作機構",
  },
  service:{
      tab1:'產品服務',
      tab2:'體檢中心',
      tab3:'健康服務',
      tab4:'社區服務',
      tab1_1:"丁丁健康智能體檢系統V3.0",
      tab1_2:"丁丁健康智能排隊系統V3.0",
      tab1_3:"丁丁健康智能LIS系統V3.0",
      tab1_4:"丁丁健康智能PACS系統V3.0",
      tab1_5:"丁丁健康智能OA系統V3.0",
      tab1_6:"丁丁健康智能健康管理系統V3.0",
      tab1_7:"丁丁健康智能回訪系統V3.0",
      tab1_8:"丁丁健康中醫體質辨識軟件V3.0",
      tab1_9:"丁丁健康婦幼保健系統V5.0",
      tab1_10:"丁丁健康職業病體檢系統V5.0",
      tab1_11:"丁丁健康APP",
      tab2_text:"強大的體檢中心管理系統，全數字化管理軟件，實現完備的體檢業務流程，為體檢中心的業務擴展提供有力的技術支撐。",
      tab3_text:"面向用戶的健康管理服務，通過逐步改善個人的生活方式和習慣，提升個人健康水平、遠離疾病。",
      tab4_text:"完善的產品體系，助力社區開展基層健康管理與用戶跟蹤服務。",
  },
  contact:{
      tab1:'加盟合作',
      tab2:'招聘精英',
      tab1_address_label_1:'廣州公司地址:',
      tab1_address_1:'廣東省廣州市黃浦區至泰廣場A4棟606',
      tab1_address_label_2:'聯系電話:',
      tab1_address_2:'',
      tab1_address_label_3:'北京公司地址:',
      tab1_address_3:'北京市密雲區康馨雅苑38號樓3單元101',
      tab1_address_label_4:'聯系電話:',
      tab1_address_4:'',
      tab1_address_label_5:'佛山公司地址:',
      tab1_address_5:'佛山順德南德醫科大學醫療大數據產業園首層110室',
      tab1_address_label_6:'聯系電話:',
      tab1_address_6:'',
      tab1_address_label_7:'重慶公司地址:',
      tab1_address_7:'重慶市九龍坡區奧體運動街150號21-4房',
      tab1_address_label_8:'联系电话:',
      tab1_address_8:'',
      tab2_address_label_1:'聯系電話:',
      tab2_address_1:'',
      tab2_address_label_2:'企業郵箱:',
      tab2_address_2:'',
      tab2_address_label_3:'公司地址:',
      tab2_address_3:'廣東省廣州市黃浦區至泰廣場A4棟606',

  },
  about: {
      tab1:'公司概況',
      tab2:'公司資質',
      company_intro_1:"澳門丁丁健康投資發展有限公司是壹家專註於大健康領域投資的領先企業，多年來壹直在國內布局線下創辦醫療機構和提供線上互聯網醫療服務業務。公司線上互聯網醫療板塊主要從事健康促進管理領域的信息技術研發，跨界整合雲架構移動互聯網技術和健康管理專業資源，以智能健康管理大數據平臺為核心，借助移動互聯網、IOT技術實現端到端的解決方案，協助各類機構、企業的健康管理部門延伸服務範圍、完善服務質量、提升服務效率，同時幫助個人用戶實現日常的健康自我管理與數據跟蹤蹤、分析。丁丁健康願努力成為每個人的貼身健康管家，使健康自我管理與健康促進成為大家每日生活中必需品。丁丁健康數字健康管理平臺成功地為醫療機構、體檢機構、社康中心、健管中心等單位提供健康管理的信息技術服務與支持。丁丁健康堅持技術持續創新、服務以人為本、不斷為客戶創造價值的發展理念，希望借助人工智能、大數據及移動互聯網的發展使更多的用戶可以關註自身健康、更容易地實現自我健康管理與促進、更好地享受健康生活。",
      company_intro_2:"公司團隊由資深信息技術專家和經驗豐富的健康顧問組成，丁丁健康健康管理平臺成功地為醫療機構、體檢機構、社康中心、健管中心等單位提供健康管理的信息技術服務與支持。丁丁健康堅持技術持續創新、服務以人為本、不斷為客戶創造價值的發展理念，希望借助人工智能、大數據及移動互聯網的發展使更多的用戶可以關註自身健康、更容易地實現自我健康管理與促進、更好地享受健康生活。",
      company_intro_3:"丁丁健康堅持技術持續創新、服務以人為本、不斷為客戶創造價值的發展理念，希望借助人工智能、大數據及移動互聯網的發展使更多的用戶可以關註自身健康、更容易地實現自我健康管理與促進、更好地享受健康生活。",
      company_qualification_1:"廣東省健康醫療大數據產業園入駐企業",
      company_qualification_2:"廣東省醫學大數據融合應用工程中心合作夥伴",
  },
};
export default langs



// WEBPACK FOOTER //
// ./src/i18n/langs/tc.js